import produce from 'immer';

import { createReducer } from '../utils';
import type { OrganizationAccessRequest } from '../../types';

import * as OrganizationAccessRequestActions from './actions';

const initialState: { organizationAccessRequests: Record<number, OrganizationAccessRequest> } = {
  organizationAccessRequests: {},
};

export default createReducer(initialState, {
  [`${OrganizationAccessRequestActions.ORGANIZATION_ACCESS_REQUEST_INVITE_EXISTING}_FULFILLED`]: (state, action) => {
    return produce(state, draftState => {
      const { id, fulfilled } = action.payload.data as OrganizationAccessRequest;
      const accessRequest = draftState.organizationAccessRequests[id];
      if (accessRequest) {
        accessRequest.fulfilled = fulfilled;
      }
    });
  },
  [`${OrganizationAccessRequestActions.ORGANIZATION_ACCESS_REQUEST_REMOVE_ACCESS_REQUEST}_FULFILLED`]: (state, action) => {
    return produce(state, draftState => {
      delete draftState.organizationAccessRequests[action.meta?.accessRequestId];
    });
  },
});
